import { TValidator } from "../../../../../wizard/types";

const validator: TValidator = async ({ values }) => {
  const errors: { [key: string]: any } = {};

  if (!values?.selectedMajors?.length) {
    errors.selectedMajors = "Major is required";
  }

  if (Object.keys(errors).length > 0) {
    throw errors;
  }
};

export default validator;
